import axios from 'axios'

import { BASE_URL } from '../Contansts'

export const submitApi = async (path, data) => {
  const body = {
    data: data,
  }
  try {
    const url = `${BASE_URL}/${path}`
    const response = await axios.post(url, body)
    return { data: response?.data?.data, error: null }
  } catch (error) {
    console.log(error)
    return { data: null, error: error?.response?.data?.error || {} }
  }
}
